import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "./Manu.css"

const Manu = () => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                <Container>
                    <Navbar.Brand href="#home"> &lt; SUJAN /&gt;</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto">
                            <Link to="/#home">Home</Link>
                            <Link to="/#skills">Skills</Link>
                            <Link to="/#portfolio">Portfolio</Link>
                            <Link to="/#contact">Contact</Link>

                        </Nav>

                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
        // <Navbar bg="light" expand="lg">
        //     <Container>
        //         <Navbar.Brand href="#home"> &lt; SUJAN /&gt;</Navbar.Brand>
        //         <Navbar.Toggle aria-controls="basic-navbar-nav" />
        //         <Navbar.Collapse id="basic-navbar-nav">
        //             <NavbarBrand className="ms-auto">
        //                 <ul>



        //                     <li>
        //                         <Link to="/home">Home</Link>
        //                     </li>
        //                     <li>
        //                         <Link to="/about">About</Link>
        //                     </li>
        //                     <li>
        //                         <Link to="/skills">Skills</Link>

        //                     </li>
        //                     <li>
        //                         <Link to="/contact">Contact</Link>

        //                     </li>
        //                 </ul>

        //             </NavbarBrand>
        //         </Navbar.Collapse>
        //     </Container>
        // </Navbar>
    );
}

export default Manu;
